import { useQuery } from '@tanstack/react-query'

import { importDipsWards } from '~/store/dips-entity.api'

import { MultiQueryOptions } from '../useMultiQuery'

/**
 * Fetch DIPS wards and put them in the store.
 *
 * @param options - (Optional) Parameters for the queries, such as skip and refetchInterval.
 */
export const useWardQuery = (options?: MultiQueryOptions) => {
    const wardQuery = useQuery({
        queryFn: () => importDipsWards(),
        queryKey: ['dipsWards'],
        enabled: !options?.skip,
        staleTime: options?.staleTime,
        refetchInterval: options?.refetchInterval,
        refetchOnWindowFocus: options?.refetchOnWindowFocus,
    })

    return wardQuery
}
